import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Navbar.css';

const NAV_LINKS = [
  { label: 'Platform', href: '/#platform' },
  { label: 'Compare', href: '/#compare' },
  { label: 'Intelligence', href: '/#ai' },
  { label: 'Product', href: '/#launch' },
  { label: 'About', href: '/#about' },
  { label: 'Contact', href: '/#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleAnchorClick = (e, href) => {
    if (href.startsWith('/#')) {
      e.preventDefault();
      const id = href.slice(2);
      if (pathname !== '/') {
        window.location.href = href;
        return;
      }
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`} role="navigation" aria-label="Main navigation">
        <div className="container navbar__inner">
          <Link to="/" className="navbar__logo" aria-label="TaxiOps home">
            <img src={logo} alt="TaxiOps logo" className="navbar__logo-img" />
          </Link>

          <ul className="navbar__links" >
            {NAV_LINKS.map(({ label, href }) => (
              <li key={label}>
                <a
                  href={href}
                  className="navbar__link"
                  onClick={(e) => handleAnchorClick(e, href)}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>

          <div className="navbar__right">
            <span className="badge badge--yellow navbar__launch-badge">
              <span className="navbar__dot" aria-hidden="true" />
              Operations Platform
            </span>
            <a
              href="mailto:info@oldalexhub.com?subject=TaxiOps Future Availability Inquiry"
              className="btn btn--primary navbar__cta"
            >
              Contact Us
            </a>
          </div>

          <button
            className={`navbar__hamburger ${menuOpen ? 'is-open' : ''}`}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span className="navbar__hamburger-bar" />
            <span className="navbar__hamburger-bar" />
            <span className="navbar__hamburger-bar" />
          </button>
        </div>
      </nav>

      {/* Mobile Drawer */}
      <div
        className={`navbar__drawer ${menuOpen ? 'navbar__drawer--open' : ''}`}
        aria-hidden={!menuOpen}
      >
        <div className="navbar__drawer-header">
          <img src={logo} alt="TaxiOps" className="navbar__logo-img" />
          <button
            className="navbar__drawer-close"
            aria-label="Close menu"
            onClick={() => setMenuOpen(false)}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
        <ul className="navbar__drawer-links" >
          {NAV_LINKS.map(({ label, href }) => (
            <li key={label}>
              <a
                href={href}
                className="navbar__drawer-link"
                onClick={(e) => handleAnchorClick(e, href)}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
        <div className="navbar__drawer-footer">
          <a
            href="mailto:info@oldalexhub.com?subject=TaxiOps Future Availability Inquiry"
            className="btn btn--primary"
            style={{ width: '100%', justifyContent: 'center' }}
          >
            Contact Old Alex Hub
          </a>
          <p className="navbar__drawer-note">info@oldalexhub.com</p>
        </div>
      </div>

      {menuOpen && (
        <div
          className="navbar__overlay"
          aria-hidden="true"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </>
  );
}
